var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-page-account-deletion-confirm"},[_c('text-body-medium',{attrs:{"weight":'extra-bold'}},[_vm._v(_vm._s(_vm.pageData.text))]),_c('button-primary',{attrs:{"text":_vm.$t('message[\'general.go-back\']')},on:{"click":function($event){return _vm.navigateBack()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }